// Utility function for authenticated API requests
export const api = (url: string, options: RequestInit = {}) => {
  const defaultOptions: RequestInit = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    credentials: 'include',
    ...options,
  };

  return fetch(url, defaultOptions);
};

// Helper for GET requests
export const apiGet = (url: string) => api(url);

// Helper for POST requests
export const apiPost = (url: string, data: any) => 
  api(url, {
    method: 'POST',
    body: JSON.stringify(data),
  });

// Helper for PUT requests
export const apiPut = (url: string, data: any) => 
  api(url, {
    method: 'PUT',
    body: JSON.stringify(data),
  });

// Helper for DELETE requests
export const apiDelete = (url: string) => 
  api(url, {
    method: 'DELETE',
  });
